import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=68a21a07&scoped=true&lang=html"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a21a07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a21a07')) {
      api.createRecord('68a21a07', component.options)
    } else {
      api.reload('68a21a07', component.options)
    }
    module.hot.accept("./Terms.vue?vue&type=template&id=68a21a07&scoped=true&lang=html", function () {
      api.rerender('68a21a07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Terms.vue"
export default component.exports